let Constants = {
  //  install
  install(Vue) {
    //  create global Constants
    Vue.prototype.$constants = {
      SIGNIN_EVENT: 'WEB_SIGNUP',
      LOGIN_EVENT: 'WEB_LOGIN',
      ST_REGISTER_WEB: 'ST_REGISTER_WEB',
      ST_LOGIN_WEB: 'ST_LOGIN_WEB',
      WEB_PAGEVIEW: 'WEB_PAGEVIEW',
      WEB_LOGIN_FBLOGIN: 'WEB_LOGIN_FBLOGIN',
      WEB_LOGIN_APPLELOGIN: 'WEB_LOGIN_APPLELOGIN',
      WEB_LOGIN_EMAILLOGIN: 'WEB_LOGIN_EMAILLOGIN',
      WEB_REGISTER_FBLOGIN: 'WEB_REGISTER_FBLOGIN',
      WEB_REGISTER_APPLELOGIN: 'WEB_REGISTER_APPLELOGIN',
      WEB_REGISTER_EMAILLOGIN: 'WEB_REGISTER_EMAILLOGIN',
      WEB_REGISTER_TC: 'WEB_REGISTER_TC',
      WEB_CONTACTUS: 'WEB_CONTACTUS',
      WEB_GOTO_WEBSITE: 'WEB_GOTO_WEBSITE',
      WEB_AUTH_SIGNUP: 'WEB_AUTH_SIGNUP',
      WEB_AUTH_LOGIN: 'WEB_AUTH_LOGIN',
      WEB_AUTH_ERROR: 'WEB_AUTH_ERROR',
      WEB_AUTH_LOGOUT: 'WEB_AUTH_LOGOUT',
      WEB_ACC_FORGOT_PWD: 'WEB_ACC_FORGOT_PWD',
      WEB_ACC_UPGRADE_PREMIUM: 'WEB_ACC_UPGRADE_PREMIUM',
      WEB_ACC_REDEEM_PROMO: 'WEB_ACC_REDEEM_PROMO',
      WEB_ACC_MANAGE_SUBS: 'WEB_ACC_MANAGE_SUBS',
      WEB_ACC_REDEEM_GIFT: 'WEB_ACC_REDEEM_GIFT',
      WEB_PROMO_ERROR: 'WEB_PROMO_ERROR',
      WEB_REDEEM_REDEEM: 'WEB_REDEEM_REDEEM',
      WEB_PROMO_REDEEMED: 'WEB_PROMO_REDEEMED',
      WEB_PAY_SUBS_YEARLY: 'WEB_PAY_SUBS_YEARLY',
      WEB_PAY_SUBS_MONTHLY: 'WEB_PAY_SUBS_MONTHLY',
      WEB_PAY_PROMO_APPLIED: 'WEB_PAY_PROMO_APPLIED',
      WEB_PAY_PROMO_ERROR: 'WEB_PAY_PROMO_ERROR',
      WEB_PAY_SUBS_PRESSED: 'WEB_PAY_SUBS_PRESSED',
      WEB_PAY_SUBS_APPLEPAY: 'WEB_PAY_SUBS_APPLEPAY',
      WEB_PAY_SUBS_GOOGLEPAY: 'WEB_PAY_SUBS_GOOGLEPAY',
      WEB_SUBS_CONFIRMED: 'WEB_SUBS_CONFIRMED',
      WEB_SUBS_CANCELED: 'WEB_SUBS_CANCELED',
      WEB_CHANGEPWD_RESTORE: 'WEB_CHANGEPWD_RESTORE',
      WEB_RESTOREPWD_DONE: 'WEB_RESTOREPWD_DONE',
      WEB_MANAGE_SUBS_UNDO: 'WEB_MANAGE_SUBS_UNDO',
      WEB_MANAGE_SUBS_UNSUBSCRIBE: 'WEB_MANAGE_SUBS_UNSUBSCRIBE',
      WEB_MANAGE_SUBS_UNSUBSCRIBE_CONFIRM:
        'WEB_MANAGE_SUBS_UNSUBSCRIBE_CONFIRM',
      WEB_PAYWALL_OPEN: 'WEB_PAYWALL_OPEN'
    }
  }
}

export default Constants
